import { newHotCityInfo, newCityList } from '@/logic/home/model';
import type { airportItem } from '@/logic/home/model';
export interface GlobalHotCityAo {
	cityCode: string;
	cityName: string;
}
export interface GlobalHotCityGroupAo {
	cityList: GlobalHotCityAo[];
	type: number;
	groupCode: string;
	groupName: string;
}
export interface GlobalSetBaseAo {
	data: {
		hotCity: GlobalHotCityGroupAo[];
		aboutUs?: any;
	};
	msg: string;
	status: number;
}
export interface CityItem {
	cityCode: string;
	cityName: string;
	countryCode?: string;
	countryName?: string;
	airportList?: airportItem[];
}

export interface CarrierItem {
	airlineCode2: string;
	airlineCode3: string | null;
	airlineLogo: string | null;
	airlineNameCn: string | null;
	airlineNameEn: string | null;
	airlineNameHk: string | null;
	airlineNameJa: string | null;
	airlineNameKo: string | null;
}

export interface GetCarrierApiAo {
	datas: CarrierItem[],
	msg: string;
	status: number;
}

export interface AirportsAo {
	msg: string;
	status: number;
	data: CityItem[];
}

export const convertGlobalAoToLo = (globalSetAo: GlobalSetBaseAo) => {
	let hotCityData = newHotCityInfo();
	if (globalSetAo && globalSetAo.data) {
		if (globalSetAo.data.hotCity) {
			hotCityData = globalSetAo?.data?.hotCity;
		}
	}
	return hotCityData;
};
export const convertAirportsAoToLo = (globalSetAo: AirportsAo) => {
	let cityList = newCityList();
	cityList = globalSetAo?.data;
	return cityList;
};
export const convertCarrierAoToLo = (carrierAo: GetCarrierApiAo) => {
	return carrierAo?.datas;
};
